/**
 * CREATE realty — feature-local safe async error normalization.
 * Do not change shared messageFromError or import password-specific helpers.
 */

export const CREATE_DRAFT_ASYNC_FALLBACK =
  "Не вдалося створити чернетку. Перевірте з'єднання і спробуйте ще раз.";

export const CREATE_SAVE_ASYNC_FALLBACK =
  "Не вдалося зберегти чернетку. Перевірте поля та спробуйте ще раз.";

export const CREATE_PUBLISH_ASYNC_FALLBACK =
  "Не вдалося опублікувати оголошення. Перевірте поля та спробуйте ще раз.";

function looksLikeHtml(value) {
  return /<\/?[a-z][\s\S]*>/i.test(value);
}

function isTransportOrRawUnsafeMessage(value) {
  if (typeof value !== "string") return true;
  const trimmed = value.trim();
  if (!trimmed) return true;
  if (looksLikeHtml(trimmed)) return true;
  if (trimmed === "Network Error") return true;
  if (/^network error$/i.test(trimmed)) return true;
  if (/ECONNABORTED|ETIMEDOUT|timeout/i.test(trimmed)) return true;
  if (/^\s*Error:/i.test(trimmed)) return true;
  if (/at\s+\S+\s+\(/.test(trimmed)) return true;
  if (/AxiosError|TypeError|ReferenceError|Internal Server Error/i.test(trimmed)) {
    return true;
  }
  // Reject English-only transport/backend noise; keep Ukrainian guidance.
  if (!/[А-Яа-яЁёІіЇїЄєҐґ]/.test(trimmed)) return true;
  return false;
}

function firstCandidateFromError(error) {
  if (error == null || error === "") return null;
  if (typeof error === "string") return error;
  if (Array.isArray(error)) {
    const first = error.find((item) => typeof item === "string");
    return first || null;
  }
  if (error.response && error.response.data != null) {
    const data = error.response.data;
    if (typeof data === "string") return data;
    if (typeof data === "object" && !Array.isArray(data)) {
      if (typeof data.detail === "string") return data.detail;
      if (Array.isArray(data.detail) && typeof data.detail[0] === "string") {
        return data.detail[0];
      }
      if (typeof data.non_field_errors === "string") return data.non_field_errors;
      if (
        Array.isArray(data.non_field_errors)
        && typeof data.non_field_errors[0] === "string"
      ) {
        return data.non_field_errors[0];
      }
    }
  }
  if (error.message && typeof error.message === "string") return error.message;
  if (error.code === "ECONNABORTED" || error.code === "ERR_NETWORK") {
    return "Network Error";
  }
  return null;
}

/**
 * Map a create-flow async failure to one safe Ukrainian message for both
 * inline submit feedback and a single toast.error.
 */
export function mapCreateAsyncError(error, fallback) {
  const safeFallback =
    typeof fallback === "string" && fallback.trim()
      ? fallback.trim()
      : CREATE_DRAFT_ASYNC_FALLBACK;
  const candidate = firstCandidateFromError(error);
  if (candidate == null) return safeFallback;
  if (isTransportOrRawUnsafeMessage(candidate)) return safeFallback;
  return candidate.trim();
}
